class SectorHasFarmRepository {
  constructor(api) {
    this.api = api;
  }
  async getByIdSector(ID_SECTOR) {
    const raw = `
      SELECT * FROM CROP.SECTOR_HAS_FARM
      WHERE ID_SECTOR = ${ID_SECTOR};
    `;

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });
    if( resp.length &&  resp[0].length){
      return resp[0][0];
    }
    return
  }

  async checkIfExistsFarm(ID_FARM){
    const raw = `
    SELECT EXISTS ( SELECT * FROM CROP.SECTOR_HAS_FARM
      WHERE ID_FARM = ${ID_FARM}) AS isExists;
  `
    const resp= await this.api.sql({
      data: {
        sql: raw
      }
    })
    if (resp[0].length) {
      let result = resp[0][0]
      return 'isExists' in result ? result.isExists : 0;
    }
    return;
  }

  async getByIdFarm(ID_FARM) {
    const raw = `
      SELECT * FROM CROP.SECTOR_HAS_FARM
      WHERE ID_FARM = ${ID_FARM};
    `;

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if( resp.length &&  resp[0].length){
      return resp[0][0];
    }
    return
  }

  async getByIdsFarm(IDS) {
    // length = 3
    let range=``

    IDS.map((id,i)=>{
      //Último item
      if(i === IDS.length-1){
        range+=id
      }else{
        range+=id+','
      }

    })
    const raw = `
      SELECT * FROM CROP.SECTOR_HAS_FARM shf
      INNER JOIN CROP.FARM f
      WHERE shf.ID_FARM = f.ID AND
      shf.ID_FARM IN (${range})
      `;
      // LIMIT 1;

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if( resp.length &&  resp[0].length){
      return resp[0];
    }
    return []
  }


  async save(ID_SECTOR, ID_FARM) {

    const raw = `
      INSERT INTO CROP.SECTOR_HAS_FARM(
        ID_SECTOR,
        ID_FARM
      )VALUES(
        ${ID_SECTOR},
        ${ID_FARM}
      );`

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });
    if(resp.length && resp[0]){
      console.log(`[SectorHasFarm] - Sucesso ao salvar ID_FARM ${ID_FARM} atrelando ao setor ${ID_SECTOR}`)
    }
    return resp.length ? resp[0] : null;

  }

  async deleteByIdSector(ID_SECTOR) {
    const raw = `
      DELETE FROM CROP.SECTOR_HAS_FARM
      WHERE ID_SECTOR = ${ID_SECTOR};
    `

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    if(resp.length && resp[0]){
      console.log(`[SectorHasFarm] - Sucesso ao deletar setor ${ID_SECTOR} e cultivar atrelado a ele`)
    }

    return resp.length ? resp[0] : null;

  }

  async updateByIdSector(ID_SECTOR,ID_FARM){
    const raw=`
      UPDATE CROP.SECTOR_HAS_FARM
      SET ID_FARM = ${ID_FARM}
      WHERE ID_SECTOR = ${ID_SECTOR};
    `

    const resp = await this.api.sql({
      data: {
        sql: raw
      }
    });

    return resp
  }



}

export {
  SectorHasFarmRepository
};
